export default "/images/vendor/flag-icon-css/flags/4x3/dz.svg?945a413c6ba8e484b7b1545494376723";